import { createApi } from '@reduxjs/toolkit/query/react';
import type { ModuleMaster } from '../../types/module.types';
import { createBaseQuery } from '../baseApi';

export const moduleApi = createApi({
  reducerPath: 'moduleApi',
  baseQuery: createBaseQuery('/modules/'),
  tagTypes: ['Modules'],
  endpoints: (builder) => ({
    getModules: builder.query<ModuleMaster[], void>({
      query: () => 'user-modules',
      providesTags: ['Modules'],
    }),
  }),
});

export const { useGetModulesQuery } = moduleApi;